import _extends from "@babel/runtime/helpers/extends";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from "react";
import { array, bool, func, object, string } from "prop-types";
import { Button, ButtonToolbar, Preloader } from "@icg360/ui-toolkit";
import RexWrapper from "./RexWrapper";
import OverrideRateValidationBlock from "./OverrideRateValidationBlock";
import EffectiveDate from "./EffectiveDate";
import Comment from "./Comment";
import SupplementalPolicyData from "./SupplementalPolicyData";
import { formFieldPropTypes, pacDataPropTypes } from "../../shared/propTypes";
import OverrideRulesetBlock from "./OverrideRulesetBlock";
import { connect } from "react-redux";

var Edit = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Edit, _Component);

  function Edit(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.updateFormValue = function (key, value) {
      var _extends2;

      _this.setState(_extends({}, _this.state, {
        formValues: _extends({}, _this.state.formValues, (_extends2 = {}, _extends2[key] = value, _extends2))
      }));
    };

    _this.formIsValid = function () {
      var _this$props = _this.props,
          rexFormHasNoChanges = _this$props.rexFormHasNoChanges,
          rexFormIsInvalid = _this$props.rexFormIsInvalid,
          rulesetsSayBlock = _this$props.rulesetsSayBlock,
          rulesetsSayPrevent = _this$props.rulesetsSayPrevent,
          effectiveDate = _this$props.effectiveDate,
          _this$props$pacData = _this$props.pacData,
          enableRulesets = _this$props$pacData.enableRulesets,
          policyActionId = _this$props$pacData.policyActionId;
      var overrideRulesetBlockers = _this.state.formValues.overrideRulesetBlockers; // 1 Effective Date

      if (effectiveDate.isRequired && !effectiveDate.isValid) {
        // eslint-disable-next-line no-console
        console.warn("Form validation fail: effective date.");
        return false;
      } // 2 Rex form


      if (rexFormIsInvalid) {
        // eslint-disable-next-line no-console
        console.warn("Form validation fail: rex form.");
        return false;
      }

      if (rexFormHasNoChanges && policyActionId !== "renewalpreview") {
        // eslint-disable-next-line no-console
        console.warn("Form validation fail: rex form.");
        return false;
      } // Check rulesets if the feature is enabled


      if (enableRulesets) {
        // 3 Ruleset prevents
        if (rulesetsSayPrevent) {
          // eslint-disable-next-line no-console
          console.warn("Form validation fail: ruleset prevent.");
          return false;
        } // 4 Ruleset blocks without override


        if (rulesetsSayBlock && !overrideRulesetBlockers) {
          // eslint-disable-next-line no-console
          console.warn("Form validation fail: ruleset block.");
          return false;
        }
      }

      return true;
    };

    _this.handleOnSubmit = function (e) {
      var formSubmitAttempted = _this.state.formSubmitAttempted;

      if (!_this.formIsValid()) {
        e.preventDefault();
      } // If a form submit hasn't been marked as attempted yet, mark it as such


      if (!formSubmitAttempted) {
        _this.setState({
          formSubmitAttempted: true
        });
      }
    };

    _this.state = {
      formSubmitAttempted: false,
      formValues: {
        overrideRulesetBlockers: false
      }
    };
    return _this;
  }

  var _proto = Edit.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        backToEditFormView = _this$props2.backToEditFormView,
        comment = _this$props2.comment,
        derivedForm = _this$props2.derivedForm,
        effectiveDate = _this$props2.effectiveDate,
        hasRateValidationBlock = _this$props2.hasRateValidationBlock,
        pacData = _this$props2.pacData,
        _this$props2$pacData = _this$props2.pacData,
        handleExternalClose = _this$props2$pacData.handleExternalClose,
        policyActionId = _this$props2$pacData.policyActionId,
        rexFormHasNoChanges = _this$props2.rexFormHasNoChanges,
        rulesets = _this$props2.rulesets,
        rulesetsSayBlock = _this$props2.rulesetsSayBlock,
        showLoadingOverlay = _this$props2.showLoadingOverlay,
        updateFormField = _this$props2.updateFormField,
        columnData = _this$props2.columnData,
        columnDataTitle = _this$props2.columnDataTitle;
    var _this$state = this.state,
        formSubmitAttempted = _this$state.formSubmitAttempted,
        overrideRulesetBlockers = _this$state.formValues.overrideRulesetBlockers; // If there's a rate validation error, just show the message to override it

    if (hasRateValidationBlock) {
      return /*#__PURE__*/React.createElement(OverrideRateValidationBlock, {
        pacData: pacData,
        backToEditFormView: backToEditFormView
      });
    }

    var formCanSubmit = formSubmitAttempted ? this.formIsValid() : true;
    return /*#__PURE__*/React.createElement("div", null, showLoadingOverlay && /*#__PURE__*/React.createElement("div", {
      style: {
        position: "absolute",
        width: "100%",
        height: "100%",
        inset: "0",
        color: "#000",
        textAlign: "center",
        backgroundColor: "rgba(255,255,255,0.8)",
        zIndex: "3"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        position: "absolute",
        top: "75%"
      }
    }, /*#__PURE__*/React.createElement(Preloader, {
      size: 150,
      style: {
        margin: "auto"
      }
    }), /*#__PURE__*/React.createElement("h3", null, "This may take a few minutes."), /*#__PURE__*/React.createElement("h3", {
      style: {
        lineHeight: "1.5"
      }
    }, "If you exit this screen your changes will be lost, but evaluating the same changes again might be quicker as the risk evaluation process will be completed behind the scenes."))), /*#__PURE__*/React.createElement(SupplementalPolicyData, {
      pacData: pacData
    }), effectiveDate.isRequired && /*#__PURE__*/React.createElement(EffectiveDate, {
      effectiveDate: effectiveDate,
      formSubmitAttempted: formSubmitAttempted,
      pacData: pacData,
      updateFormField: updateFormField
    }), policyActionId !== "renewalpreview" && /*#__PURE__*/React.createElement(Comment, {
      comment: comment,
      updateFormField: updateFormField
    }), /*#__PURE__*/React.createElement(RexWrapper, {
      derivedForm: derivedForm,
      formSubmitAttempted: formSubmitAttempted,
      overrideRulesetBlockers: overrideRulesetBlockers,
      pacData: pacData,
      rulesets: rulesets,
      columnData: columnData,
      columnDataTitle: columnDataTitle
    }), rulesetsSayBlock && /*#__PURE__*/React.createElement(OverrideRulesetBlock, {
      pacData: pacData,
      updateFormValue: this.updateFormValue,
      value: overrideRulesetBlockers
    }), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-xs-6"
    }, !formCanSubmit && /*#__PURE__*/React.createElement("p", {
      className: "text-danger"
    }, "Fix any issues", rexFormHasNoChanges ? " and propose at least one change " : " ", "before previewing changes.")), /*#__PURE__*/React.createElement("div", {
      className: "col-xs-6"
    }, /*#__PURE__*/React.createElement(ButtonToolbar, {
      className: "pull-right"
    }, handleExternalClose && /*#__PURE__*/React.createElement(Button, {
      onClick: handleExternalClose
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      bsStyle: "primary",
      type: "submit",
      disabled: !formCanSubmit,
      onClick: this.handleOnSubmit
    }, "Preview Changes")))));
  };

  return Edit;
}(Component);

Edit.propTypes = {
  backToEditFormView: func.isRequired,
  comment: formFieldPropTypes.isRequired,
  derivedForm: array.isRequired,
  effectiveDate: formFieldPropTypes.isRequired,
  hasRateValidationBlock: bool.isRequired,
  pacData: pacDataPropTypes.isRequired,
  rexFormHasNoChanges: bool.isRequired,
  rexFormIsInvalid: bool.isRequired,
  rulesets: array.isRequired,
  rulesetsSayBlock: bool.isRequired,
  rulesetsSayPrevent: bool.isRequired,
  showLoadingOverlay: bool,
  updateFormField: func.isRequired,
  columnData: object,
  columnDataTitle: string
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    showLoadingOverlay: state.analysisValidation.isLoading
  };
};

export default connect(mapStateToProps)(Edit);